import { CLUB } from "../data/mockData";

export const Klubinfo = () => {
  return (
    <section
      id="info"
      data-testid="klubinfo-section"
      className="border-t border-neutral-900 bg-neutral-950 py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <span className="section-eyebrow">06 · Om klubben</span>
            <h2 className="mt-5 font-heading text-5xl uppercase leading-none tracking-tight text-white sm:text-6xl">
              Sådan er vi.
            </h2>
            <p className="mt-6 font-body text-lg leading-relaxed text-neutral-300">
              {CLUB.description}
            </p>
            <dl className="mt-10 grid grid-cols-2 gap-y-6">
              <div>
                <dt className="mono-label text-neutral-500">Stadion</dt>
                <dd className="mt-1 font-body text-white">{CLUB.stadium}</dd>
              </div>
              <div>
                <dt className="mono-label text-neutral-500">Adresse</dt>
                <dd className="mt-1 font-body text-white">{CLUB.address}</dd>
              </div>
              <div>
                <dt className="mono-label text-neutral-500">Sammenlagt</dt>
                <dd className="mt-1 font-body text-white">
                  {CLUB.founded}
                  <span className="ml-2 mono-label text-neutral-500">
                    B70 + TIK 90
                  </span>
                </dd>
              </div>
              <div>
                <dt className="mono-label text-neutral-500">Farver</dt>
                <dd className="mt-1 flex items-center gap-2 font-body text-white">
                  <span className="inline-block h-3 w-3 bg-brand" />
                  Lys grøn / Sort
                </dd>
              </div>
              <div className="col-span-2">
                <dt className="mono-label text-neutral-500">
                  Tidligere TFC-spillere
                </dt>
                <dd className="mt-1 font-body text-white">
                  {CLUB.historicPlayers.join(" · ")}
                </dd>
              </div>
            </dl>
          </div>

          <div className="lg:col-span-7">
            <div className="grid gap-4 sm:grid-cols-2">
              {CLUB.values.map((v, i) => (
                <div
                  key={v.label}
                  data-testid={`klub-value-${v.label.toLowerCase()}`}
                  className="group relative border border-neutral-800 bg-black p-6 transition-colors hover:border-brand"
                >
                  <span className="mono-label text-neutral-500">
                    0{i + 1}
                  </span>
                  <h3 className="mt-4 font-heading text-3xl uppercase tracking-tight text-white">
                    {v.label}
                  </h3>
                  <p className="mt-3 font-body text-sm text-neutral-400">
                    {v.detail}
                  </p>
                  <span className="absolute right-5 top-5 font-heading text-5xl text-neutral-800 transition-colors group-hover:text-brand/40">
                    ·
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
